// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"ContactUs_backBtn__2lXZt","contactText":"ContactUs_contactText__AhEuW","contactTitle":"ContactUs_contactTitle__3LboG"};